import '@rainbow-me/rainbowkit/styles.css'
import { useCallback, useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate } from 'react-router-dom'

import brandConfig from 'brandConfig'
// import { buildMultiLanguageLink } from '../components/shared/buildMultiLanguageLink'
import TermsNotAcceptedWrapper from 'wrappers/TermsNotAcceptedWrapper'
import AuthorizedLayout from '../components/authorizedLayout/AuthorizedLayout'
import FeatureLockedPopup from '../components/popups/common/FeatureLocked'
import { DEFAULT_CONTAINER_STATE } from '../constants/containerStates'
import {
  changePurchaseTierState,
  purchaseTierWithPoints,
  refreshKYCInfo
} from '../store/actions/account'
import {
  acceptTerms,
  changeSignupInputAndErrorState,
  changeSignupState,
  signOut,
  resetConfirmEmail
} from '../store/actions/auth'
import { changeKYCState } from '../store/actions/kyc'
import { changeMainState } from '../store/actions/main'
import { KYC_PROFILE_DISPATCH } from '../store/reducers/account/kyc'
import { SIGNUP_PROFILE_DISPATCH } from '../store/reducers/auth/signup'
import { MAIN_PROFILE_DISPATCH } from '../store/reducers/main/main'
import { getWalletAddressSelector } from '../store/selectors/wallet'
import { extractCognitoUserTermsAccepted } from '../util/auth.helpers'
import { CURRENCIES, findTierLevelById } from '../util/staking/staking.helpers'
import PurchaseStatusPopup from '../components/popups/common/PurchaseStatus'
import PurchaseStatusSuccessPopup from '../components/popups/common/PurchaseStatusSuccess'
import WalletNotification from '../components/popups/common/WalletNotification'
import { STAKING_URL } from '../constants/navigation'
import { setLWAConf } from '../util/local.helpers'
import { shouldShowWalletNotification } from '../util/app/app.helpers'
import NoQBXNotification from '../components/popups/common/NoQBXNotification'
import { getSignedUrl } from '../store/actions/redeem'
import { buildCOEUrl } from '../util/navigation.helpers'
import { usePreviousState } from '../hooks/usePreviousState'
import { buildTiersToPurchase } from '../util/staking/membership.helpers'
import { PURCHASE_TIER_PROFILE_DISPATCH } from '../store/reducers/account/purchaseTier'
import EmailChangeConfirmation from '../components/popups/common/EmailChangeConfirmation'
import PurchaseStatusConfirmation from '../components/popups/common/PurchaseStatusConfirmation'

const AuthorizedLayoutContainer = ({
  children,
  authProfile: { cognitoUser, initSignOut, error, confirmEmail },
  signOut,
  changeSignupState,
  acceptTerms,
  signupProfile,
  changeSignupInputAndErrorState,
  // enablePurchasePoints,
  isQuestsEnabled,
  changeMainState,
  walletConnectProps,
  changeKYCState,
  kycProfile,
  refreshKYCInfo,
  initKYCProcess,
  purchaseTierWithPoints,
  purchaseTierProfile,
  getSignedUrl,
  changePurchaseTierState,
  resetConfirmEmail,
  ...restProps
}) => {
  const {
    // selectedLanguage,
    // openLanguagePopup,
    // renderLanguagePopup,
    tokenProfile,
    mainProfile,
    accountProfile,
    stakingProfile
  } = restProps

  const navigate = useNavigate()

  const { onWalletClick, renderWalletPopup } = walletConnectProps

  const [noQBXPopup, setNoQBXPopup] = useState(false)

  const handleAcceptTermsSubmit = () => {
    const { termsAccepted, privacyPolicyAccepted, mandatoryCheckbox } =
      signupProfile
    const { features } = brandConfig
    const {
      disableTermsCheckbox,
      disablePrivacyCheckbox,
      enableMandatoryCheckbox
    } = features
    const termsPolicy = !disableTermsCheckbox ? termsAccepted : true
    const privacyPolicy = !disablePrivacyCheckbox ? privacyPolicyAccepted : true
    if (enableMandatoryCheckbox) {
      if (termsPolicy && privacyPolicy && mandatoryCheckbox) {
        acceptTerms()
      } else {
        changeSignupState(SIGNUP_PROFILE_DISPATCH.ERROR, {
          termsAccepted: true,
          privacyPolicyAccepted: true,
          mandatoryCheckbox: true
        })
      }
    } else if (termsPolicy && privacyPolicy) {
      acceptTerms()
    } else {
      changeSignupState(SIGNUP_PROFILE_DISPATCH.ERROR, {
        termsAccepted: true,
        privacyPolicyAccepted: true
      })
    }
  }

  const handleToggleNav = () => {
    changeMainState(MAIN_PROFILE_DISPATCH.IS_NAV_MINI, !mainProfile.isNavMini)
  }

  const walletAddressMembership = useSelector(getWalletAddressSelector)

  const connectedWallet = walletAddressMembership.membershipNumber

  const termsAccepted = extractCognitoUserTermsAccepted(cognitoUser)

  useEffect(() => {
    if (!termsAccepted) {
      changeMainState(MAIN_PROFILE_DISPATCH.LOADING, false)
    }
  }, [termsAccepted])

  useEffect(() => {
    if (purchaseTierProfile.tier) {
      changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
        id: DEFAULT_CONTAINER_STATE.PURCHASE_STATUS_SUCCESS,
        data: {
          tier: purchaseTierProfile.tier
        }
      })
    }
  }, [purchaseTierProfile.tier])

  const handlePurchaseStatus = useCallback((currency, tier) => {
    changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
      id: DEFAULT_CONTAINER_STATE.PURCHASE_STATUS_CONFIRMATION,
      data: {
        currency,
        tier
      }
    })
  }, [])

  const prevAvailableQBX = usePreviousState(stakingProfile.availableQBX)

  useEffect(() => {
    const { availableQBX } = stakingProfile
    if (
      shouldShowWalletNotification(accountProfile.insertedAt) &&
      !mainProfile.loading
    ) {
      if (
        !connectedWallet &&
        !mainProfile.lwaConf?.hideWalletNotify &&
        availableQBX <= 0
      ) {
        changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
          id: DEFAULT_CONTAINER_STATE.WALLET_CONNECT
        })
        setNoQBXPopup(false)
        return
      }
      const shouldShowQBXPopup =
        connectedWallet &&
        availableQBX !== null &&
        availableQBX === 0 &&
        prevAvailableQBX === null
      setNoQBXPopup(shouldShowQBXPopup)
    }
  }, [
    connectedWallet,
    stakingProfile.availableQBX,
    accountProfile.insertedAt,
    mainProfile.loading
  ])

  const handleNoPopup = () => {
    changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
      id: DEFAULT_CONTAINER_STATE.NONE
    })
    setNoQBXPopup(false)
  }

  const handleOpenNoQBX = () => {
    setNoQBXPopup(true)
  }

  const updateConf = (attr) => {
    const conf = {
      ...mainProfile.lwaConf,
      ...attr
    }
    changeMainState(MAIN_PROFILE_DISPATCH.LWA_CONF, conf)
    setLWAConf(conf)
  }

  const handleCancelPopup = (attr) => {
    updateConf(attr)
    handleNoPopup()
  }

  const renderPopup = () => {
    if (!termsAccepted) {
      return (
        <TermsNotAcceptedWrapper
          signupProfile={signupProfile}
          dispatchActionSignup={changeSignupInputAndErrorState}
          onAcceptTermsSubmit={handleAcceptTermsSubmit}
          onCancelTerms={signOut}
          changeSignupState={changeSignupState}
          acceptTerms={acceptTerms}
        />
      )
    } else if (confirmEmail || error?.emailTemp) {
      return (
        <EmailChangeConfirmation
          success={confirmEmail}
          error={error?.emailTemp}
          onSubmit={resetConfirmEmail}
        />
      )
    } else if (
      kycProfile.popupState?.id === DEFAULT_CONTAINER_STATE.FEATURE_LOCKED
    ) {
      const popupData = kycProfile.popupState?.data
      return (
        <FeatureLockedPopup
          onCancel={handleNoPopup}
          onSubmit={handleNoPopup}
          mainProfile={mainProfile}
          kycProfile={kycProfile}
          onContinueKYC={initKYCProcess}
          tierRequirement={findTierLevelById(
            mainProfile.tiers,
            popupData?.targetTierId
          )}
          checkKyc={!popupData?.noKyc}
          onRefreshKYC={refreshKYCInfo}
        />
      )
    } else if (
      kycProfile.popupState?.id === DEFAULT_CONTAINER_STATE.PURCHASE_STATUS
    ) {
      const handleOnSubmit = () => {
        handleNoPopup()
        changePurchaseTierState(PURCHASE_TIER_PROFILE_DISPATCH.ERROR, {})
      }
      return (
        <PurchaseStatusPopup
          onCancel={handleOnSubmit}
          onSubmit={handleOnSubmit}
          mainProfile={mainProfile}
          symbol={tokenProfile.symbol}
          onPurchase={handlePurchaseStatus}
          purchaseTierProfile={purchaseTierProfile}
          tiersForPurchase={buildTiersToPurchase(mainProfile)}
        />
      )
    } else if (
      kycProfile.popupState?.id ===
      DEFAULT_CONTAINER_STATE.PURCHASE_STATUS_CONFIRMATION
    ) {
      const data = kycProfile.popupState?.data
      const handleOnCancel = () => {
        changePurchaseTierState(PURCHASE_TIER_PROFILE_DISPATCH.ERROR, {})
        changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
          id: DEFAULT_CONTAINER_STATE.PURCHASE_STATUS
        })
      }
      const handleOnSubmit = () => {
        if (data?.currency !== CURRENCIES.USD) {
          purchaseTierWithPoints(data?.tier)
        }
      }
      return (
        <PurchaseStatusConfirmation
          onCancel={handleOnCancel}
          onSubmit={handleOnSubmit}
          symbol={tokenProfile.symbol}
          isProcessing={purchaseTierProfile.isProcessing}
          {...data?.tier}
        />
      )
    } else if (
      kycProfile.popupState?.id ===
      DEFAULT_CONTAINER_STATE.PURCHASE_STATUS_SUCCESS
    ) {
      return (
        <PurchaseStatusSuccessPopup
          onCancel={handleNoPopup}
          onSubmit={handleNoPopup}
          tier={{ id: 3, name: 'Sapphire' }}
          {...kycProfile.popupState?.data}
        />
      )
    } else if (noQBXPopup) {
      const handleOnSubmit = () => {
        handleNoPopup()
        navigate(STAKING_URL)
      }
      return (
        <NoQBXNotification
          onCancel={handleNoPopup}
          onSubmit={handleOnSubmit}
          symbol={tokenProfile.symbol}
        />
      )
    } else if (
      kycProfile.popupState?.id === DEFAULT_CONTAINER_STATE.WALLET_CONNECT
    ) {
      const handleOnSubmit = () => {
        handleCancelPopup({ hideWalletNotify: true })
        navigate(STAKING_URL)
        onWalletClick()
      }
      return (
        <WalletNotification
          onCancel={() => {
            handleCancelPopup({ hideWalletNotify: true })
          }}
          onSubmit={handleOnSubmit}
          symbol={tokenProfile.symbol}
        />
      )
    }
  }

  const handleOpenCOEStore = () => {
    getSignedUrl(buildCOEUrl())
  }

  return (
    <>
      <AuthorizedLayout
        {...restProps}
        signOut={signOut}
        initSignOut={initSignOut}
        onToggleNav={handleToggleNav}
        onWalletClick={onWalletClick}
        connectedWallet={connectedWallet}
        // multiLanguage={buildMultiLanguageLink(
        //   selectedLanguage,
        //   openLanguagePopup,
        //   renderLanguagePopup
        // )}
        isQuestsEnabled={isQuestsEnabled}
        walletConnectProps={walletConnectProps}
        onOpenCOEStore={handleOpenCOEStore}
        onOpenNoQBX={handleOpenNoQBX}
      >
        {children}
      </AuthorizedLayout>
      {renderPopup()}
      {renderWalletPopup()}
    </>
  )
}

const mapStateToProps = ({
  authReducer,
  mainReducer,
  accountReducer,
  stakingReducer
}) => {
  const { authProfile, signupProfile } = authReducer
  const { tokenProfile, mainProfile } = mainReducer
  const { kycProfile, purchaseTierProfile } = accountReducer
  const { stakingProfile } = stakingReducer
  return {
    authProfile,
    signupProfile,
    tokenProfile,
    mainProfile,
    kycProfile,
    purchaseTierProfile,
    stakingProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut,
      changeSignupInputAndErrorState,
      changeSignupState,
      acceptTerms,
      changeMainState,
      changeKYCState,
      refreshKYCInfo,
      purchaseTierWithPoints,
      getSignedUrl,
      changePurchaseTierState,
      resetConfirmEmail
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthorizedLayoutContainer)
